module.exports = __webpack_public_path__ + "img/framework.9b497e2d.png";